export default "__VITE_ASSET__BDqQeP8o__"